(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref400"];
var parcelRegister = parcelRequire.register;
parcelRegister("9Q2vk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01d935514d7c1186$export$2e2bcd8739ae039; });

var $jbXyA = parcelRequire("jbXyA");

var $J7ygF = parcelRequire("J7ygF");

var $hvJJn = parcelRequire("hvJJn");

var $1vaY4 = parcelRequire("1vaY4");
var $01d935514d7c1186$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function CollectionFilter(param) {
        var el = param.el, isLargeQuery = param.isLargeQuery;
        (0, $J7ygF._)(this, CollectionFilter);
        this.el = el;
        this.isLargeQuery = isLargeQuery;
        this.filterToggles = Array.from(this.el.querySelectorAll(".filter-toggle"));
        // actual filtering
        this.form = this.el.querySelector("form");
        this.checkboxes = Array.from(this.el.querySelectorAll(".filter-checkbox"));
        this.containerElString = this.el.getAttribute("data-container-el");
        this.productsListContainer = document.getElementById(this.containerElString);
        this.productData = this.productsListContainer.querySelector(".product-data");
        this.searchParamsInitial = window.location.search.slice(1);
        this.searchParamsPrev = window.location.search.slice(1);
        this.resetButton = this.el.querySelector(".reset-button");
        this.productCount = this.el.querySelector(".product-count");
        this.filterType = this.el.getAttribute("data-type");
        this.sectionToRender = this.filterType === "collection" ? "main-collection-list" : "main-search-list";
        this.init();
    }
    (0, $hvJJn._)(CollectionFilter, [
        {
            key: "init",
            value: function init() {
                var _this = this;
                this.filterToggles.forEach(function(toggle) {
                    toggle.addEventListener("click", function(e) {
                        e.preventDefault();
                        if (_this.el.classList.contains("active")) _this.close();
                        else _this.open();
                    });
                });
                // click outside to close
                document.addEventListener("click", function(e) {
                    if (!_this.el.contains(e.target)) _this.close();
                });
                // filter checkboxes
                this.checkboxes.forEach(function(checkbox) {
                    checkbox.addEventListener("change", function() {
                        var params = _this.getSearchParams();
                        _this.renderPage(params);
                    });
                });
                var _this1 = this;
                this.resetButton.addEventListener("click", function() {
                    var _ref = (0, $jbXyA._)(function(e) {
                        return (0, $1vaY4.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    e.preventDefault();
                                    return [
                                        4,
                                        _this1.renderPage(false, true, true)
                                    ];
                                case 1:
                                    _state.sent();
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(e) {
                        return _ref.apply(this, arguments);
                    };
                }());
                window.addEventListener("popstate", this.onHistoryChange.bind(this));
            }
        },
        {
            key: "open",
            value: function open() {
                this.el.classList.add("active");
            }
        },
        {
            key: "close",
            value: function close() {
                this.el.classList.remove("active");
            }
        },
        {
            key: "renderPage",
            value: function renderPage(searchParams) {
                var updateFilters = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, updateUrl = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                var _this = this;
                return (0, $jbXyA._)(function() {
                    var url;
                    return (0, $1vaY4.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                console.log(searchParams);
                                // set previous search params
                                _this.searchParamsPrev = searchParams;
                                _this.productData = _this.productsListContainer.querySelector(".product-data");
                                _this.productData.style.opacity = ".3";
                                _this.productCount.innerHTML = "Loading...";
                                if (updateUrl) _this.updateUrl(searchParams);
                                // check if search params is empty
                                if (!searchParams) _this.el.classList.add("hide-reset");
                                else _this.el.classList.remove("hide-reset");
                                // update form filters
                                if (updateFilters) _this.checkboxes.forEach(function(checkbox) {
                                    var paramChecker = checkbox.dataset.paramChecker;
                                    if ((searchParams === null || searchParams === void 0 ? void 0 : searchParams.filterParams) && searchParams.filterParams.includes(paramChecker)) checkbox.checked = true;
                                    else checkbox.checked = false;
                                });
                                // get filter url
                                url = "".concat(window.location.pathname, "?").concat(searchParams.q ? "q=".concat(searchParams.q, "&") : "", "section_id=").concat(_this.sectionToRender).concat(searchParams.filterParams ? "&".concat(searchParams.filterParams) : "");
                                // fetch new products list via section rendering api
                                return [
                                    4,
                                    fetch(url).then(function(response) {
                                        return response.text();
                                    }).then(function(html) {
                                        var resultsMarkup = new DOMParser().parseFromString(html, "text/html");
                                        var productHTML = resultsMarkup.querySelector("#products-list-container").innerHTML;
                                        var productCount = parseInt(resultsMarkup.querySelector(".product-data").dataset.count);
                                        // update products list
                                        _this.productsListContainer.innerHTML = productHTML;
                                        _this.productCount.innerHTML = productCount === 1 ? "1 Item" : "".concat(productCount, " Items");
                                    })
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "getSearchParams",
            value: function getSearchParams() {
                // check if there is a 'q' search param in url
                var url = new URL(window.location);
                var searchParams = url.searchParams;
                var q = searchParams.get("q");
                var formData = new FormData(this.form);
                return {
                    q: q,
                    filterParams: new URLSearchParams(formData).toString()
                };
            }
        },
        {
            key: "updateUrl",
            value: function updateUrl(searchParams) {
                if (searchParams) history.pushState({
                    searchParams: searchParams
                }, "", "".concat(window.location.pathname, "?").concat(searchParams.q ? "q=".concat(searchParams.q).concat(searchParams.filterParams ? "&" : "") : "").concat(searchParams.filterParams));
                else history.pushState({}, "", "".concat(window.location.pathname));
            }
        },
        {
            key: "onHistoryChange",
            value: function onHistoryChange(e) {
                var searchParams = e.state ? e.state.searchParams : this.searchParamsInitial;
                if (searchParams === this.searchParamsPrev) return;
                this.renderPage(searchParams, true, false);
            }
        }
    ]);
    return CollectionFilter;
}();

});
parcelRegister("jbXyA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $df8d3e20ddc8da14$export$71511d61b312f219; });
function $df8d3e20ddc8da14$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $df8d3e20ddc8da14$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $df8d3e20ddc8da14$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $df8d3e20ddc8da14$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("J7ygF", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $087a0fb22a93b2d1$export$71511d61b312f219; });
function $087a0fb22a93b2d1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("hvJJn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cbf8ce221d4c5514$export$71511d61b312f219; });
function $cbf8ce221d4c5514$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cbf8ce221d4c5514$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cbf8ce221d4c5514$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("1vaY4", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $118131b1cbbf3c94$export$67ebef60e6f28a6; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $5euqn = parcelRequire("5euqn");
var $118131b1cbbf3c94$var$extendStatics = function extendStatics1(d, b) {
    $118131b1cbbf3c94$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $118131b1cbbf3c94$var$extendStatics(d, b);
};
function $118131b1cbbf3c94$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $118131b1cbbf3c94$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $118131b1cbbf3c94$export$18ce0697a983be9b = function __assign1() {
    $118131b1cbbf3c94$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $118131b1cbbf3c94$export$18ce0697a983be9b.apply(this, arguments);
};
function $118131b1cbbf3c94$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $118131b1cbbf3c94$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $118131b1cbbf3c94$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $118131b1cbbf3c94$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $118131b1cbbf3c94$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $118131b1cbbf3c94$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $5euqn._)(x)) === "symbol" ? x : "".concat(x);
}
function $118131b1cbbf3c94$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $5euqn._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $118131b1cbbf3c94$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $118131b1cbbf3c94$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $118131b1cbbf3c94$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $118131b1cbbf3c94$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $118131b1cbbf3c94$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $118131b1cbbf3c94$export$45d3717a4c69092e(o, m, p);
}
function $118131b1cbbf3c94$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $118131b1cbbf3c94$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $118131b1cbbf3c94$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($118131b1cbbf3c94$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $118131b1cbbf3c94$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $118131b1cbbf3c94$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $118131b1cbbf3c94$export$10c90e4f7922046c(v) {
    return this instanceof $118131b1cbbf3c94$export$10c90e4f7922046c ? (this.v = v, this) : new $118131b1cbbf3c94$export$10c90e4f7922046c(v);
}
function $118131b1cbbf3c94$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $118131b1cbbf3c94$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $118131b1cbbf3c94$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $118131b1cbbf3c94$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $118131b1cbbf3c94$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $118131b1cbbf3c94$export$19a8beecd37a4c45 === "function" ? $118131b1cbbf3c94$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $118131b1cbbf3c94$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $118131b1cbbf3c94$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $118131b1cbbf3c94$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $118131b1cbbf3c94$export$45d3717a4c69092e(result, mod, k);
    }
    $118131b1cbbf3c94$var$__setModuleDefault(result, mod);
    return result;
}
function $118131b1cbbf3c94$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $118131b1cbbf3c94$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $118131b1cbbf3c94$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $118131b1cbbf3c94$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $118131b1cbbf3c94$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $118131b1cbbf3c94$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $118131b1cbbf3c94$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $118131b1cbbf3c94$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $118131b1cbbf3c94$export$2e2bcd8739ae039 = {
    __extends: $118131b1cbbf3c94$export$a8ba968b8961cb8a,
    __assign: $118131b1cbbf3c94$export$18ce0697a983be9b,
    __rest: $118131b1cbbf3c94$export$3c9a16f847548506,
    __decorate: $118131b1cbbf3c94$export$29e00dfd3077644b,
    __param: $118131b1cbbf3c94$export$d5ad3fd78186038f,
    __metadata: $118131b1cbbf3c94$export$f1db080c865becb9,
    __awaiter: $118131b1cbbf3c94$export$1050f835b63b671e,
    __generator: $118131b1cbbf3c94$export$67ebef60e6f28a6,
    __createBinding: $118131b1cbbf3c94$export$45d3717a4c69092e,
    __exportStar: $118131b1cbbf3c94$export$f33643c0debef087,
    __values: $118131b1cbbf3c94$export$19a8beecd37a4c45,
    __read: $118131b1cbbf3c94$export$8d051b38c9118094,
    __spread: $118131b1cbbf3c94$export$afc72e2116322959,
    __spreadArrays: $118131b1cbbf3c94$export$6388937ca91ccae8,
    __spreadArray: $118131b1cbbf3c94$export$1216008129fb82ed,
    __await: $118131b1cbbf3c94$export$10c90e4f7922046c,
    __asyncGenerator: $118131b1cbbf3c94$export$e427f37a30a4de9b,
    __asyncDelegator: $118131b1cbbf3c94$export$bbd80228419bb833,
    __asyncValues: $118131b1cbbf3c94$export$e3b29a3d6162315f,
    __makeTemplateObject: $118131b1cbbf3c94$export$4fb47efe1390b86f,
    __importStar: $118131b1cbbf3c94$export$c21735bcef00d192,
    __importDefault: $118131b1cbbf3c94$export$da59b14a69baef04,
    __classPrivateFieldGet: $118131b1cbbf3c94$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $118131b1cbbf3c94$export$d40a35129aaff81f,
    __classPrivateFieldIn: $118131b1cbbf3c94$export$81fdc39f203e4e04,
    __addDisposableResource: $118131b1cbbf3c94$export$88ac25d8e944e405,
    __disposeResources: $118131b1cbbf3c94$export$8f076105dc360e92
};

});
parcelRegister("5euqn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cf5dc3c2ce8e525$export$71511d61b312f219; });
function $3cf5dc3c2ce8e525$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});



})();
//# sourceMappingURL=CollectionFilter.2265d09e.js.map
